import { FEATURE_FLAG_DEFAULTS } from '@vizit/constants';

/**
 * Default feature flag values
 * These are used as fallbacks when LaunchDarkly is unavailable or slow to load
 *
 * Values are imported from @vizit/constants to keep them in sync
 */
export const DEFAULT_FLAGS = FEATURE_FLAG_DEFAULTS;

export type FlagKey = keyof typeof DEFAULT_FLAGS;
export type FlagValue = (typeof DEFAULT_FLAGS)[FlagKey];
